import { Component, ViewChild } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationService } from '@m4u-angular/core/framework/notification.service';
import { Subscription } from 'rxjs';
import { Notification } from '@m4u-angular/base/entities/BaseEntities';
import { Message, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-toasts',
    templateUrl: './push-message-toasts.component.html',
    styleUrls: ['./push-message-toasts.component.scss']
})
export class PushMessageToastsComponent extends BaseComponent<BaseState> {

    private notificationsSubscription: Subscription;
    Notifications: Notification[] = [];

    @ViewChild('toast') toast: Toast;
    
    constructor(A: ServiceBagService,
        private notificationService: NotificationService,
        private messageService: MessageService) {
        super(A, 'PushMessageToastsComponent', BaseState);
    }

    protected override OnInitComponent() {
        this.notificationsSubscription = this.notificationService.Notifications$
            .subscribe((notifications: Notification[]) => {
                this.Notifications = notifications;
                
                const messages = this.Notifications.map(x => this.ConvertToMessage(x));
                this.ShowToasts(messages);
            });
    }

    private ConvertToMessage(notitification: Notification): Message {
        return { 
            id: notitification.EntryID, 
            key: 'pm', 
            life: 15000, 
            closable: false, 
            styleClass: 'push-message-toast', 
            data: notitification 
        } as Message;
    }

    private ShowToasts(messages: Message[]) {
        setTimeout(() => this.messageService.addAll(messages), 1000);
    }

    OnNotificationRead(notitication: Notification) {
        const messageToDeleteIndex = this.toast.messages.findIndex(x => x.id === notitication.EntryID);
        const messageToDelete = this.toast.messages.find(x => x.id === notitication.EntryID);
        this.toast.onMessageClose({ index: messageToDeleteIndex, message: messageToDelete });
    }

    protected override OnDestroyComponent(): void {
        this.notificationsSubscription && this.notificationsSubscription.unsubscribe();
    }
}
